import React, { useEffect, useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom';


import ModalContext from '../../context/ModalContext.js';
import DrawerContext from '../../context/DrawerContext.js';

//assets
import placeholder from '../../assets/img/blog/placeholder.png';
import editButton from '../../assets/img/blog/edit.svg';
import deleteButton from '../../assets/img/blog/delete.svg';

import { Button, CircularProgress, Card } from '@mui/material'
import { AddRounded } from '@mui/icons-material';
import CustomButton from '../../common/CustomButton.jsx';
import { listPosts, blogApiConfigured } from '../../utils/blogApi';

const Blogs = () => {

  const modalCtx = useContext(ModalContext);
  const drawerCtx = useContext(DrawerContext);
  const navigate = useNavigate();

  function toggleDrawerHandler(drawer, user) {
    drawerCtx.openDrawer();
    drawerCtx.setDetails(drawer, user);
  };

  const [blogs, setBlogs] = useState([])
  const [blogPage, setBlogPage] = useState(1)

  // updating status states 
  const [updatingStatus, setUpdatingStatus] = useState(false);
  const [loadingBlogs, setLoadingStatus] = useState(true);
  const [updatingStatusId, setUpdatingStatusId] = useState();
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    getAllBlogs()
  }, []);

  useEffect(() => {
    if (modalCtx.pageUpdate?.page === 'Blogs') {
      getAllBlogs();
      modalCtx.setPageUpdate({});
    }
  }, [modalCtx.pageUpdate]);

  useEffect(() => {
    if (drawerCtx.pageUpdate?.page === 'Blogs') {
      getAllBlogs();
      drawerCtx.setPageUpdate({});
    }
  }, [drawerCtx.pageUpdate]);

  const handleModal = (modal, data) => {
    modalCtx.openModal();
    modalCtx.setDetails(modal, data);
  }

  const getAllBlogs = () => {

    if (!blogApiConfigured()) {
      setLoadError('The blog service is not configured. Set REACT_APP_BLOG_API_URI.');
      setLoadingStatus(false);
      return;
    }

    listPosts({ page: blogPage })
      .then(result => {
        setBlogs(result?.data ?? []);
        setLoadError(null);
      })
      .catch(err => {
        console.error(err);
        setBlogs([]);
        setLoadError(err.message);
      })
      .finally(() => {
        setUpdatingStatus(false);
        setLoadingStatus(false);
      });

  }


  const getStatusClass = (slug) => {
    let blog = blogs?.find(obj => obj.slug === slug);
    if (blog && blog.status == 'published') {
      return 'author-tag published';
    } else {
      return 'author-tag draft';
    }
  }

  const postStatusClass = (slug) => {
    let blog = blogs?.find(obj => obj.slug === slug);
    if (blog && blog.status == 'published') {
      return 'post-status published';
    } else {
      return 'post-status draft';
    }
  }
  function showRegDate(unFormattedDate) {
    if (unFormattedDate == null || unFormattedDate === undefined) return '—';
    const date = new Date(unFormattedDate);
    if (isNaN(date.getTime())) return '—';
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  }

  /** Get display date from blog – published date only */
  function getBlogDate(blog) {
    return blog?.publishedAt;
  }

  /** blog-api returns the primary author as `author`; extra credits are not listed. */
  function getAuthorDisplay(blog) {
    const name = blog?.author?.name;
    return name ? { text: name, count: 1 } : { text: null, count: 0 };
  }

  const openDeleteDevotionalModal = (blog) => {
    modalCtx.setDetails('confirm-delete-blog', { slug: blog.slug, title: blog.title });
    modalCtx.openModal();
  }
  const openPublishModal = (blog) => {
    modalCtx.setDetails('confirm-publish-blog', { blog });
    modalCtx.openModal();
  }

  const openUploadImageModal = (blog) => {
    modalCtx.setDetails('upload-fixed-image', { aspectRatio: 1.6, origin: 'blog', slug: blog.slug });
    modalCtx.openModal();
  }

  return (

    <div className="blogs-page">

      <header className="template-header" >
        <h1 className='df-center' data-aos="fade-right" data-aos-delay="500">Blogs &nbsp; {loadingBlogs ? <CircularProgress size={22} /> : null}</h1>
        <div>
          <CustomButton data-aos="fade-right" data-aos-delay="400" onClick={() => { toggleDrawerHandler('create-blog', null) }}>Create New</CustomButton>
        </div>
      </header>

      <section className='template-section' >
        <div className='blogs'>
          {
            !blogs?.length
              ? <div className="no-blogs">{loadError || 'No Blogs'}</div>
              : <> {
                blogs?.map((blog, index) => {
                  const authorDisplay = getAuthorDisplay(blog);
                  return (
                  <Card className='blog-card' key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <div className={postStatusClass(blog.slug)}></div>

                    {
                      blog.coverImageUrl
                        ?
                        <div className='blog-img-container' onClick={() => openUploadImageModal(blog)}>
                          <img src={blog.coverImageUrl} alt='blog' className='devotional-img bg-image' />
                        </div>
                        :
                        <div className='placeholder-img' onClick={() => openUploadImageModal(blog)}>
                          <img src={placeholder} alt="placeholder" />
                          <span className='placeholder-text' >No image. Click to Add a image</span>
                        </div>
                    }

                    <div align="left" className='blog-title'>

                      <p className='blog-title-text' >{blog.title}</p>
                      <p className='blog-title-date' ><span>Post Date -</span>{showRegDate(getBlogDate(blog))}</p>

                      <div className='tags-row'>
                        <div
                          className='tag'
                          style={authorDisplay.text ? { background: '#f1f1f1', color: '#222', border: '1px solid #666' } : null}
                          onClick={() => handleModal('edit-blog-author', blog)}
                          title='Author'
                        >
                          {!authorDisplay.text && <AddRounded className='add-tag action-icon' />}
                          {authorDisplay.text || 'Author'}
                          {authorDisplay.count > 1 ? <div className='number-icon'>{authorDisplay.count}</div> : null}
                        </div>
                        <div className='tag' onClick={() => handleModal('edit-blog-topics', blog)} >
                          <AddRounded className='add-tag action-icon' />
                          Topic
                          {blog.topics?.length > 1 ? <div className='number-icon'>{blog.topics?.length}</div> : null}
                        </div>
                        <div className='tag' onClick={() => handleModal('edit-blog-tags', blog)} >
                          <AddRounded className='add-tag action-icon' />
                          Tag
                          {blog.tags?.length > 1 ? <div className='number-icon'>{blog.tags?.length}</div> : null}
                        </div>
                      </div>

                      <div className='editable-row'>
                        <div className='status-row'>
                          <span>Status -</span>
                          <div className="author-tags" onClick={() => openPublishModal(blog)}>
                            {
                              (updatingStatus && updatingStatusId == blog.id) ?
                                <CircularProgress size={20} />
                                :
                                <span className={getStatusClass(blog.slug)}>{(blog.status || 'draft').toUpperCase()}</span>
                            }
                          </div>
                        </div>
                        <div className='edit-btns df-center'>
                          <div className='df-center edit-btn' onClick={() => toggleDrawerHandler('edit-blog', blog)}><img src={editButton} alt='button'></img></div>
                          <div className='df-center edit-btn' onClick={() => openDeleteDevotionalModal(blog)}><img src={deleteButton} alt='button'></img></div>
                        </div>
                      </div>

                    </div>

                  </Card>
                ); })
              }
              </>
          }

        </div>
      </section>
    </div>
  )
}

export default Blogs;
